import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { store } from "~/store";
import { ConfigProvider } from "antd";
import {StyleProvider} from '@ant-design/cssinjs';

import '@fortawesome/fontawesome-free/css/all.min.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Montserrat",
            colorPrimary: '#00A551',
            fontSize: 16
          },
          components: {
            Button: {
              colorPrimary: '#00A551',
            }
          }
        }}>
          <StyleProvider hashPriority= "high">
            <App />
          </StyleProvider>
      </ConfigProvider>
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
